const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

function getServiceWorkerUrl() {
  return `${process.env.PUBLIC_URL || ""}/pwa-sw.js`;
}

export function register() {
  if (!("serviceWorker" in navigator)) return;

  const start = () => {
    const swUrl = getServiceWorkerUrl();
    if (isLocalhost || process.env.NODE_ENV === "development") {
      checkValidServiceWorker(swUrl);
      return;
    }
    // updateViaCache "none": always fetch the worker script from the network.
    navigator.serviceWorker
      .register(swUrl, { updateViaCache: "none" })
      .catch((error) => {
        console.error("Error during service worker registration:", error);
      });
  };

  if (document.readyState === "complete") {
    start();
    return;
  }
  window.addEventListener("load", start);
}

function checkValidServiceWorker(swUrl: string) {
  fetch(swUrl, { headers: { "Service-Worker": "script" } })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister();
        });
      } else {
        navigator.serviceWorker.register(swUrl).catch(() => undefined);
      }
    })
    .catch(() => {
      navigator.serviceWorker.register(swUrl).catch(() => undefined);
    });
}
